import { ConnectorSpec, OperationListItem } from '@integration-app/sdk'
import { useState } from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import classes from 'routes/Connectors/Connector/components/ExecuteOperations/executeOperations.module.css'
import { Hgroup } from 'routes/components/Hgroup'
import { Markdown } from 'routes/components/Markdown'
import { DOCS_LINK } from 'routes/constants'
import { truncate } from 'helpers/truncate'

const INITIAL_OPERATIONS_COUNT = 6

export function ExecuteOperations({
  connector,
  operations,
}: {
  connector: ConnectorSpec
  operations: OperationListItem[]
}) {
  const [showAll, setShowAll] = useState(false)
  const toggleShowAll = () => setShowAll(!showAll)

  if (!operations.length) {
    return null
  }

  const showOperations = showAll
    ? operations
    : operations.slice(0, INITIAL_OPERATIONS_COUNT)

  return (
    <div className={classes.wrapper}>
      <Hgroup>
        <h2>Execute {connector.name} operations on behalf of your customers</h2>
        <p>
          Get information about available operations in a consistent way: name,
          description, input, output. Run operations using simple consistent
          API.
        </p>
        <p>
          <a href={`${DOCS_LINK}/connectors/operations`}>
            Read more about operations
          </a>
        </p>
      </Hgroup>
      <div className={classes.events}>
        <ResponsiveMasonry
          columnsCountBreakPoints={{ 350: 1, 750: 2, 1000: 3 }}
        >
          <Masonry gutter={'1.6rem'}>
            {showOperations.map((operation) => (
              <Operation operation={operation} key={operation.key} />
            ))}
          </Masonry>
        </ResponsiveMasonry>
      </div>
      {operations.length > INITIAL_OPERATIONS_COUNT && (
        <div className={classes.buttonWrapper}>
          <button
            type={'button'}
            className={'button button__rounded button__bordered'}
            onClick={toggleShowAll}
          >
            {showAll ? 'Collapse' : `Show all ${operations.length} operations`}
          </button>
        </div>
      )}
    </div>
  )
}

function Operation({ operation }: { operation: OperationListItem }) {
  return (
    <div className={classes.event} key={operation.key}>
      <h4 className={classes.event_title}>{operation.name}</h4>
      <div className={classes.event_description}>
        <Markdown>{truncate(operation.description)}</Markdown>
      </div>
    </div>
  )
}
